(function () {
  'use strict';

  // Delegación de eventos: un solo listener en document en vez de uno por
  // trigger. Más liviano con muchos triggers (ej. una PLP con decenas de
  // cards) y sigue funcionando con triggers agregados al DOM después de
  // cargar la página (scroll infinito, filtros, paginación AJAX) — con
  // listeners individuales, esos quedarían sin conectar.
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var trigger = event.target.closest('[id^="nitSearchLoginTrigger"]');
    if (!trigger) return;

    var popup = document.getElementById('nitSearchPopup');
    if (!popup) {
      console.warn('[Moxie] #nitSearchPopup no está en el DOM — no se pudo abrir desde este trigger.');
      return;
    }
    event.preventDefault();
    popup.classList.add('active');
  });
})();
